/**
 * PageMainElement — F12.H T12.H.2.
 *
 * Główna treść strony rekordu — wrapper container na sekcje formularza.
 * Większość rekordów ma JEDEN PageMain jako default container.
 *
 * Settings: { maxWidth?: 'sm'|'md'|'lg'|'xl'|'full' }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const MAX_WIDTH_CLASS: Record<string, string> = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  full: 'max-w-full',
};

export const PageMainElement: LayoutElementDefinition = {
  type: 'page-main',
  category: 'struktura',
  isContainer: true,
  label: 'Główna treść',
  icon: 'Square',
  defaultSettings: () => ({
    maxWidth: 'full',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as { maxWidth?: string };
    const widthClass = MAX_WIDTH_CLASS[settings.maxWidth ?? 'full'] ?? 'max-w-full';
    const isBuilder = mode === 'builder';
    const hasChildren = children.length > 0;

    return (
      <main
        className={`${widthClass} mx-auto w-full ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition rounded p-2' : ''}`}
        data-testid={`page-main-element-${element.id}`}
        data-element-type="page-main"
      >
        {hasChildren ? (
          <div className="space-y-4">{children}</div>
        ) : isBuilder ? (
          <div className="rounded border-2 border-dashed border-border-primary py-8 text-center text-sm text-text-muted">
            Przeciągnij sekcje lub elementy tutaj
          </div>
        ) : null}
      </main>
    );
  },
};
